export default "__VITE_ASSET__myKKsUYb__"